const removeTagFromField = (tag: string, val: string) => {
  return val.startsWith(tag) ? val.replace(tag, '') : '';
};

const additionalFielsUtil = {
  removeTagFromField,
};

export default additionalFielsUtil;
